import { useContext, useEffect, useState } from 'react'
import { DomainContext } from '../../../../context/DomainContext';
import { SearchParamsLink } from '../../../../utils';
import { useTranslation } from 'react-i18next';

export const useGetTableData = (tableAPI, tableFiller) => {
    const { i18n } = useTranslation();

    const [data, setData] = useState([])
    const [totalRows, setTotalRows] = useState([])

    const { setDataLoading, dataLoading, searchData, customSearchData, reloadTable } = useContext(DomainContext);

    const fetchData = () => {
        let link = SearchParamsLink(searchData, customSearchData, tableFiller)
        setDataLoading(l => l + 1)
        tableAPI(link)
            .then((result) => {
                setDataLoading((l) => l - 1);
                setData(result.data || []);
                setTotalRows(result.totalCount);
            }
            )
            .catch(() => {
                setDataLoading((l) => l - 1);
            });
    };

    
    useEffect(() => {

        const featchDataTimeOut = setTimeout(() => {
            fetchData()
        }, 400)
        return () => clearTimeout(featchDataTimeOut)

    }, [reloadTable, searchData, customSearchData, tableFiller ,i18n.language])

    return { data, totalRows }

}
